import React from 'react'
import Card from 'react-bootstrap/Card'

export const UserInfoCard = ({ user }) => {
    // 1. Count how many details are available
    const itemCount = [user?.emailId, user?.mobileNo, user?.panNumber].filter(Boolean).length;

    return (
        // 2. Apply a conditional style to the Card component
        <Card
            bg='light'
            className='user-detail-card'
            style={itemCount === 1 ? { maxWidth: '400px', margin: '0 auto' } : {}}
        >
            <Card.Body className='p-4'>
                {/* We'll also center the text inside for a better look on a single item */}
                <ul className={`list-unstyled d-flex mb-0 ${itemCount === 1 ? 'justify-content-center text-center' : ''}`}>
                    <li>
                        <p className="small fw-medium opacity-75 mb-0">Email ID</p>
                        <p className='fw-medium text-dark mb-0'>{user?.emailId}</p>
                    </li>

                    {/* Conditional rendering for Mobile No. */}
                    {user?.mobileNo && user.mobileNo.trim() !== '' && (
                        <li className=''>
                            <p className="small fw-medium opacity-75 mb-0">Mobile No.</p>
                            <p className='fw-medium text-dark mb-0'>+91 {user.mobileNo}</p>
                        </li>
                    )}

                    {/* Conditional rendering for PAN No. */}
                    {user?.panNumber && user.panNumber.trim() !== '' && (
                        <li className=''>
                            <p className="small fw-medium opacity-75 mb-0">PAN No.</p>
                            <p className='fw-medium text-dark mb-0'>{user.panNumber}</p>
                        </li>
                    )}
                </ul>
            </Card.Body>
        </Card>
    )
}
